export default function MySQL_MINMAX() {
  return (
    <div>
      <h2>MySQL_MINMAX</h2>    </div>
  );
}